import React from 'react';
import { Button } from 'reactstrap';
import { useNavigationActions } from '../../../../context';
import { DowngradeBillingDetailsFooter } from '../../../shared';

/**
 * Component that displays the confirmation message after plan has been successfully downgraded to $15/month
 * Shows downgrade confirmation and encourages continued engagement
 */
const PlanDowngradeConfirmation = () => {
  // Get actions from context
  const { returnToWLC } = useNavigationActions();

  return (
    <div className="plan-downgrade-confirmation-content">
      <div className="mb-4">
        <h5 className="mb-3">Your plan has been updated. Welcome to your discounted $15/month membership.</h5>
        <p className="mb-3">
          Your WHOLE Life Club membership remains fully active with access to all your recipes, lessons, Wellness Buddy,
          and community features.
        </p>
        <p className="mb-4">
          We're so glad you're staying with us, and we hope this lighter monthly rate helps you keep building healthy
          habits that last.
        </p>

        <div className="mb-4 text-center">
          <Button color="primary" size="lg" onClick={returnToWLC} className="mb-3">
            Return to WHOLE Life Club
          </Button>
        </div>

        <p className="mb-4">Thank you for being part of the movement for healthy people and a healthy planet.</p>

        <DowngradeBillingDetailsFooter className="pause-details mb-3" />
      </div>
    </div>
  );
};

export default PlanDowngradeConfirmation;
